import { render, staticRenderFns } from "./carbonyl.vue?vue&type=template&id=048765f9&"
import script from "./carbonyl.vue?vue&type=script&lang=js&"
export * from "./carbonyl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports